import { Accordion, AccordionDetails, AccordionSummary, Checkbox } from "@mui/material";
import React, { useMemo } from "react";
import { icon, IconComponent } from "../../../../icon-component";
import styles from "./ExpandableRow.module.css";
import { CustomTooltip } from "../../../../tooltip";
import { isNonEmptyArray, multiSort } from "../../../../../utils";

// quick win for tree selection
const IS_PARENT_SELECTABLE = false;

const ExpandableRow = ({ checkedItems = [], item, indentLevel = 0, onCheck, onIsChecked, readOnly }) => {
	const isChecked = useMemo(() => onIsChecked(item), [onIsChecked, item]);
	const hasSubItems = useMemo(() => isNonEmptyArray(item.subitems), [item]);
	const handleCheck = () => {
		onCheck(item, isChecked);
	};
	return (
		<Accordion
			expanded
			classes={{
				root: styles.accordion__root,
			}}
			style={{
				marginLeft: indentLevel > 0 ? 32 : 0,
			}}
		>
			<AccordionSummary
				classes={{
					root: styles.accordionSummary__root,
					content: styles.accordionSummary__content,
				}}
				onClick={() => {
					if ((IS_PARENT_SELECTABLE && hasSubItems) || !hasSubItems) {
						handleCheck();
					}
				}}
			>
				{hasSubItems && (
					<IconComponent
						className={styles.expandIcon}
						color="var(--grey-600)"
						icon={
							((item.expanded || item.filtered !== undefined) && icon.faChevronDown) ||
							icon.faChevronRight
						}
						size="lg"
					/>
				)}
				{((IS_PARENT_SELECTABLE && hasSubItems) || !hasSubItems) && (
					<Checkbox checked={isChecked} className={styles.checkBox} disabled={readOnly} size="small" />
				)}
				{(item.subitems?.length > 0 && (
					<CustomTooltip showWhenOverflow title={item.name}>
						<span
							className={`${styles.categoryName}`}
							data-is-not-selectable-parent={hasSubItems && !IS_PARENT_SELECTABLE}
							data-is-parent={hasSubItems}
						>
							{item.name}
						</span>
					</CustomTooltip>
				)) || (
					<CustomTooltip showWhenOverflow title={item.name}>
						<span className={styles.categoryName}>{item.name}</span>
					</CustomTooltip>
				)}
			</AccordionSummary>
			<AccordionDetails
				classes={{
					root: styles.accordionDetails__root,
				}}
			>
				{isNonEmptyArray(item.subitems) &&
					multiSort(item.subitems, ["name"]).map((subItem) => (
						<ExpandableRow
							key={subItem.uuid}
							checkedItems={checkedItems}
							indentLevel={indentLevel + 1}
							item={subItem}
							readOnly={readOnly}
							onCheck={onCheck}
							onIsChecked={onIsChecked}
						/>
					))}
			</AccordionDetails>
		</Accordion>
	);
};

export default ExpandableRow;
